	<template>
    <div>
        <div class=" row mb-2 mt-3">
            <label class="col-sm-4  text-lr"><i
                    v-if="Data.data.c_priority==='S'"
                    class="fa fa-asterisk text-danger font10 ml-1"
                    aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
            <div class="col-sm-7 ">
        <span>
           <el-input
               type="textarea"         @change.self="$get_function(Data,value)"
               placeholder="请输入内容"
               v-model="value"
               maxlength="500"
               show-word-limit
           >
          </el-input>
        </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "txt",
    props: [
        'Data'
    ],
    data() {
        return {
            value: this.Data.data.c_value,
        }
    },
  created() {
  },
  watch: {},
  methods: {
  }
}
</script>
<style scoped>
</style>